import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import DropDownOptions from './DropDownOptions';

class CustomSelect extends Component {
  static propTypes = {
    options: PropTypes.instanceOf(Array),
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    multi: PropTypes.bool,
    lazy: PropTypes.bool,
    lazyPageStart: PropTypes.number,
    lazyHasMoreItems: PropTypes.bool,
    lazyLoadMoreItems: PropTypes.func,
    defaultSelectedItem: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Array)]),
  };

  static defaultProps = {
    options: [],
    placeholder: 'Select',
    multi: false,
    lazy: false,
  };

  constructor(props) {
    super(props);
    // create a ref to store the textInput DOM element
    this.textInput = null;

    this.setTextInputRef = element => {
      this.textInput = element;
    };

    this.focusTextInput = () => {
      // Focus the text input using the raw DOM API
      if (this.textInput) this.textInput.focus();
    };

    this.state = {
      isDropdown: false,
      activeOptions: [],
      filteredOptions: props.options,
      options: props.options,
      userInput: '',
      inputWidth: 44,
    };
  }

  UNSAFE_componentWillMount() {
    if (this.props.multi) {
      if (this.props.defaultSelectedItem && this.props.defaultSelectedItem.length > 0) {
        const activeOptions = [];
        this.props.options.map(item => {
          const isIncludes = this.props.defaultSelectedItem.includes(item.accountId);
          if (isIncludes) {
            activeOptions.push(item);
          }
          return false;
        });
        this.setState({ activeOptions });
      }
    } else if (this.props.defaultSelectedItem) {
        this.setState({ activeOptions: this.props.options[this.props.defaultSelectedItem] }, () => {
          this.handleDropdownItemClick(false, this.props.options[this.props.defaultSelectedItem]);
        });
      }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.hideDropdown, false);
  }

  UNSAFE_componentWillReceiveProps(nextProps, { clearOptoins = false }) {
    // if (clearOptoins) {
    //   this.setState({ activeOptions: [] });
    // }
    if (nextProps.clearOptoins) {
      this.setState({ activeOptions: [] });
    }
    if (this.props.defaultSelectedItem !== undefined && this.props.tabName === 'ca') {
      if (this.props.defaultSelectedItem !== nextProps.defaultSelectedItem) {
        if (nextProps.defaultSelectedItem === '' || nextProps.defaultSelectedItem === null) {
          this.setState({
            userInput: nextProps.defaultSelectedItem,
            activeOptions: [],
          });
        }
        if (nextProps.defaultSelectedItem && nextProps.defaultSelectedItem !== '') {
          this.setState({
            userInput: nextProps.defaultSelectedItem.sortcode === undefined ?
             nextProps.defaultSelectedItem.value : nextProps.defaultSelectedItem.sortcode,
          });
        }
      } else {
        const activeOptions = [];
        this.setState({
          userInput: 
	          this.props.defaultSelectedItem &&
            this.props.defaultSelectedItem.sortcode === undefined
              ? this.props.defaultSelectedItem &&
                this.props.defaultSelectedItem.value
              : this.props.defaultSelectedItem &&
                this.props.defaultSelectedItem.sortcode,
          activeOptions: activeOptions.push(nextProps.defaultSelectedItem),
        });
      }
    }
  }


  componentWillUnmount() {
    document.removeEventListener('mousedown', this.hideDropdown, false);
  }

  onContainerClick = e => {
    e.stopPropagation();
    this.focusTextInput();
    this.setState({ isDropdown: true });
  }

  onInputChange = e => {
    const userInput = e.target.value;
    // Filter our options that don't contain the user's input
    const filteredOptions = this.props.options.filter(
      option =>
        option.label.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ userInput, filteredOptions, isDropdown: true }, () => {
      let inputWidth = '';
      if (userInput.trim().length > 1) {
        inputWidth = ((userInput.trim().length - 1) * 7) + 51;
      }
      this.setState({ inputWidth });
    });
  }

  handleKeyDown = e => {
    const { activeOptions } = this.state;
    if (!_.isEmpty(activeOptions)) {
      if (e.key === 'Backspace') {
        const value = e.target.value;
        if (value.length === 0) {
          const newOptions = _.dropRight(activeOptions);
          this.setState({ activeOptions: newOptions }, () => {
            this.handleOnChange();
          });
        }
      }
    }
  }

  hideDropdown = e => {
    if (this.node.contains(e.target)) {
      return;
    }
    this.setState({ isDropdown: false });
  }

  showDropdown = e => {
    if (e) {
      e.stopPropagation();
    }
    this.setState({ isDropdown: !this.state.isDropdown }, () => {
      if (this.state.isDropdown) {
        this.focusTextInput();
      }
    });
  }

  handleOnChange = () => {
    const { activeOptions } = this.state;
    this.props.onChange(activeOptions);
  }

  handleDropdownItemClick = (e, item) => {
    if (item && item !== '') {
    if (e) {
      e.stopPropagation();
    }
    const { activeOptions } = this.state;
    const { multi } = this.props;
    this.setState({
      activeOptions: multi ? [...activeOptions, item] : item,
      filteredOptions: this.props.options,
      userInput: multi ? '' : item.sortcode === undefined ? item.label : item.sortcode,
      inputWidth: '',
    }, () => {
      this.handleOnChange();
      this.setState({ isDropdown: false });
    });
  }
  }

  removeSelectedItem = (e, item) => {
    e.stopPropagation();
    const { activeOptions } = this.state;
    const updatedSelectedItems = _.filter(activeOptions, a => a.value !== item.value);
    this.setState({ activeOptions: updatedSelectedItems }, () => {
      this.handleOnChange();
    });
  }

  renderSelectedItems = () => {
    const { activeOptions } = this.state;
    return _.map(activeOptions, item => (
      <span key={item.value} className="dd-menu--label--pill" value={item.value} title={item.label}>
        {item.label}
        <button type="button" className="dd-menu--label--clear" onClick={e => this.removeSelectedItem(e, item)}>
          <i className="clear-x-icon" />
        </button>
      </span>
    ));
  }

  render() {
    const { isDropdown, activeOptions, userInput, inputWidth, filteredOptions } = this.state;
    const {
      multi,
      placeholder,
      lazy,
      lazyHasMoreItems,
      lazyLoadMoreItems,
      lazyPageStart,
    } = this.props;
    const activeDropdownOptions = multi ? activeOptions : [activeOptions];

    let containerClass = isDropdown ? 'custom-select-dd custom-select-dd--active' : 'custom-select-dd';

    if (multi) {
      containerClass = `${containerClass} custom-select-dd--multi`;
    }

    let inputWidthStyle = {};

    if (multi) {
      inputWidthStyle = {
        width: inputWidth,
      };
    } else {
      inputWidthStyle = {
        width: '100%',
      };
    }

    return (
      <div
        ref={node => { this.node = node; }}
        className={containerClass} onClick={e => this.onContainerClick(e)}
      >
        {multi && !_.isEmpty(activeOptions) && this.renderSelectedItems()}
        <input
          className="custom-select-dd--control"
          autoComplete="off"
          tabIndex="0"
          type="text"
          value={userInput}
          ref={this.setTextInputRef}
          onChange={this.onInputChange}
          style={inputWidthStyle}
          onKeyDown={this.handleKeyDown}
          placeholder={multi ? '' : placeholder}
        />
        {
          !userInput && multi && _.isEmpty(activeOptions) && (
            <div className="custom-select-dd--placeholder dd-menu--label--pill">
              {placeholder}
            </div>
          )
        }
        <button
          type="button"
          onClick={e => this.showDropdown(e)}
          className="dd-menu--btn"
        >
          <i className={isDropdown ? 'dd-up-arrow-icon' : 'dd-down-arrow-icon'} />
        </button>
        {
          isDropdown && (
            <DropDownOptions
              filteredOptions={filteredOptions}
              activeOptions={activeDropdownOptions}
              handleDropdownItemClick={this.handleDropdownItemClick}
              close={this.showDropdown}
              multi={multi}
              lazy={lazy}
              lazyLoadMoreItems={lazyLoadMoreItems}
              lazyHasMoreItems={lazyHasMoreItems}
              lazyPageStart={lazyPageStart}
            />
          )
        }
      </div>
    );
  }
}

export default CustomSelect;

